import { FinancialServicesUIProvider } from '@shipstation/financial-services-ui-components';

import { useFsuiContext } from './fsui-context-provider';
import { useLocale } from '../intl/hooks';

/**
 * @param {object} params
 * @param {React.ReactNode} params.children
 * @param {import('@shipstation/financial-services-ui-components').BillingInfoData} [params.initialBillingInfo]
 * @returns {JSX.Element}
 */
export const FinancialServicesUIProviderWrapper = ({ children, initialBillingInfo }) => {
  const { preloadedSession: initialSession, apiConfig } = useFsuiContext();
  const { locale } = useLocale();

  return (
    <FinancialServicesUIProvider
      apiConfig={apiConfig}
      billingInfo={initialBillingInfo}
      initialSession={initialSession}
      locale={locale}
      useMantine
    >
      {children}
    </FinancialServicesUIProvider>
  );
};
